.circle {
    box-shadow: 0 15px 25px 0 rgba(0, 0, 0, .23);
    width: 160px;
    height: 160px;
    border-radius: 50%;
    margin: 0 auto;
    opacity: 70%;
}

.circleContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    cursor: grab;
}

/* --- draggable / reorderable list --- */
/* --item is the pitch of one item (210px on desktop), set from ColorCircleList */
.reorderRow {
    position: relative;
    height: calc(var(--item) * 0.76 + 50px);
    margin: 0 auto;
    touch-action: none;
}

.reorderRow .circle {
    width: calc(var(--item) * 0.76);
    height: calc(var(--item) * 0.76);
}

.reorderItem {
    position: absolute;
    top: 0;
    left: 0;
    height: calc(var(--item) * 0.76 + 50px);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
    cursor: grab;
    transform-origin: 50% 50%;
    will-change: transform;
    touch-action: none;
    user-select: none;
}

.reorderItem:active {
    cursor: grabbing;
}

.reorderItem p {
    margin: 0;
    font-size: clamp(11px, calc(var(--item) * 0.08), 16px);
    text-align: center;
}
